import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createContext, useContext, useState } from "react";
var defaultContestContext = {
    ContestId: null,
    setContestId: function () { return undefined; },
};
export var ContestContext = createContext(defaultContestContext);
export var ContestContextProvider = function (props) {
    var _a = useState(localStorage.getItem("selected-Contest-event-id") || null), Contest = _a[0], setContest = _a[1];
    var setContestId = function (ContestId) {
        localStorage.setItem("selected-Contest-event-id", ContestId || "");
        setContest(ContestId);
    };
    // Setup the context provider
    return (_jsx(ContestContext.Provider, { value: {
            ContestId: Contest,
            setContestId: setContestId,
        }, children: props.children }));
};
export var useContestStore = function () {
    var _a = useContext(ContestContext), ContestId = _a.ContestId, setContestId = _a.setContestId;
    return [ContestId, setContestId];
};
